import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { IMAGE_TYPES } from '../../../../constants';

const questions = [
  {
    field: 'zaludSti_recentTest',
    label:
      'Have you received a positive STI test for Chlamydia, Gonorrhea or Trichomoniasis in the past 30 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label: 'Please upload your positive test results for your provider to review. The format must be PDF, JPG, or PNG with the results and date of test clearly visible.',
    field: 'zaludSti_upload',
    type: 'file_upload',
    accepts: IMAGE_TYPES,
    answer: [
      {
        resourceId: 'zaludSti_upload',
        buttonLabel: 'Upload results'
      }
    ]
  },
  {
    class: 'ineligible',
    field: 'zalud_general_ineligible',
    type: 'info',
    educationalSlide: `Our provider cannot provide treatment without a positive test result for Chlamydia, Gonorrhea or Trichomoniasis. Please visit a local, in-person clinic or view our at-home STI test <a href="https://www.zalud.com/product/std-sti-test" id="LabTestLink" target="_blank" rel="noopener">here</a>.`,
    answer: {},
    isLast: true,
    blockQuestionFlow: true
  },
  {
    field: 'zaludSti_intake_symptoms_q1a',
    label: 'Are you currently experiencing any of the following symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'eye_discharge', value: 'Unusual eye discharge' },
        { key: 'rash_joint_pain', value: 'New or unusual rash or joint pain' },
        {
          key: 'headache_neck_stiffness',
          value: 'New headache or neck stiffness'
        },
        {
          key: 'vision_hearing_changes',
          value: 'Sudden changes in your vision or hearing'
        },
        {
          key: 'urinary_inability',
          value: `Inability to urinate or feeling like your bladder won't empty`
        },
        {
          key: 'rectal_symptoms',
          value:
            'Rectal symptoms (such as pain, bleeding, or the constant urge to pass stool)'
        },
        { key: 'none', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },

  {
    field: 'zaludSti_intake_symptoms_q1b',
    label: 'Are you currently experiencing any of the following symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'eye_discharge', value: 'Unusual eye discharge' },
        { key: 'rash_joint_pain', value: 'New or unusual rash or joint pain' },
        {
          key: 'testicular_pain_swelling',
          value: 'Testicular pain or swelling'
        },
        {
          key: 'headache_neck_stiffness',
          value: 'New headache or neck stiffness'
        },
        {
          key: 'vision_hearing_changes',
          value: 'Sudden changes in your vision or hearing'
        },
        {
          key: 'urinary_inability',
          value: `Inability to urinate or feeling like your bladder won't empty`
        },
        {
          key: 'rectal_symptoms',
          value:
            'Rectal symptoms (such as pain, bleeding, or the constant urge to pass stool)'
        },
        { key: 'none', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },

  {
    field: 'zaludSti_intake_current_situation',
    label: 'Do any of the following apply to your current situation?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'symptoms_persisted_after_treatment',
          value:
            'My current symptoms have persisted despite receiving treatment for them within the last 30 days.'
        },
        {
          key: 'seeking_care_sexual_assault',
          value: 'I am seeking care related to a recent sexual assault.'
        },
        { key: 'none', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zaludSti_intake_recent_treatment',
    label:
      'Have you been treated with medication for an STI in the last 30 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'zaludSti_intake_current_symptoms',
    label:
      'Are you currently experiencing any of the following? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'fever', value: 'Fever (100.4 degrees or above)' },
        { key: 'pelvic_pain', value: 'Pelvic pain' },
        { key: 'nausea_vomiting', value: 'Nausea and/or vomiting' },
        {
          key: 'foul_vaginal_discharge',
          value: 'Foul-smelling vaginal discharge'
        },
        { key: 'abdominal_pain', value: 'Abdominal pain' },
        { key: 'none', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zaludSti_disqualify',
    label: 'Positive Result required',
    type: 'info',
    educationalSlide: `Our provider cannot provide treatment without a positive test result for Chlamydia, Gonorrhea or Trichomoniasis. Please visit a local, in-person clinic or view our at-home STI test <a href="https://www.zalud.com/product/std-sti-test" id="LabTestLink" target="_blank" rel="noopener">here</a>.`,
    answer: {},
    isLast: true,
    blockQuestionFlow: true
  },
  {
    field: 'zaludSti_intake_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
] as const;

const _type = questions;
export type ZaludSTIQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof _type>
>;
const zaludSTIQuestions = questions;
export default zaludSTIQuestions;
